/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import {
    GraphQLObjectType as ObjectType,
    GraphQLString as StringType,
    GraphQLID as ID,
    GraphQLNonNull as NonNull,
} from 'graphql';


const PageType = new ObjectType({
    name: 'PageItem',
    description: 'Cet objet represente une page standard',
    fields: () => ({
        id: {
            type: new NonNull(ID),
            description: 'Le id de la page',
            resolve: (root) => root.id
        },
        slug: {
            type: StringType,
            description: 'Le slug de la page',
            resolve: (root) => root.slug
        },
        title: {
            type: StringType,
            description: 'Le titre de la page',
            resolve: (root) => root.title.rendered
        },
        content: {
            type: StringType,
            description: 'Le content de la page',
            resolve: (root) => root.content.rendered
        },
    }),
});

export default PageType;



// WEBPACK FOOTER //
// ./data/types/PageType.js